import { useQuery, UseQueryResult } from 'react-query';
import { Address } from '../../../../types/Common';
import { AddressResponseProps } from '../../../../types/ToolkitAddress';
import { VehicleLicense } from '../../../../types/VehicleResponse';
import { wgApi } from '../../../app/src/features/api/wgApi';

export interface PremiumAddressResponse {
  data: AddressResponseProps;
  license: VehicleLicense;
}

const getAddressPremiumInfo = async (address?: Address) => {
  const { data, isError } = await wgApi.get<Response>(
    `v1/api/address/info/premium`,
    { query: { ...address } },
  );
  if (isError) throw new Error();
  return data;
};

export const getuseAddressCoordsQKey = (
  address?: Address,
): (string | undefined)[] =>
  ['address-info', 'premium', Object.values(address || {})].flat();

export const useAddressPremiumInfo = (
  address?: Address,
): UseQueryResult<PremiumAddressResponse> => {
  return useQuery(
    getuseAddressCoordsQKey(address),
    () => getAddressPremiumInfo(address),
    {
      refetchOnWindowFocus: false,
      enabled: !!address,
    },
  );
};
